export default __webpack_public_path__ + "dc3fd5a40c82661da93fdec9c4c6ced9.png";